.toolbar { display: flex; align-items: center; gap: var(--space-2); height: 48px; flex: none; padding: 0 var(--space-3) 0 var(--space-4); border-bottom: 1px solid var(--color-border); background: var(--color-surface); }
.toolbar[data-selection] { background: var(--color-surface-selected); padding-left: var(--space-2); }
.title { font-size: var(--text-md); font-weight: var(--weight-semibold); color: var(--color-text); }
.spacer { flex: 1; }
.range { color: var(--color-text-muted); font-size: var(--text-xs); font-variant-numeric: tabular-nums; }
.hint { margin-left: auto; color: var(--color-text-muted); font-size: var(--text-xs); }
.spin { animation: spin 900ms linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) { .spin { animation: none; } }
